import CryptoJS from "crypto-js";

// Fixed IV = [0..15]
const iv = CryptoJS.enc.Hex.parse(
  [...Array(16).keys()].map(n => n.toString(16).padStart(2, "0")).join("")
);

// Derive PBKDF2 key using HmacSHA1 (like PHP)
function deriveKey(password, salt) {
  return CryptoJS.PBKDF2(password, CryptoJS.enc.Utf8.parse(salt), {
    keySize: 256 / 32, // 32 bytes
    iterations: 65536,
    hasher: CryptoJS.algo.SHA1
  });
}

export function encryptAES(data, password, salt) {
  const key = deriveKey(password, salt);

  const encrypted = CryptoJS.AES.encrypt(data, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  // Return HEX like PHP bin2hex()
  return CryptoJS.enc.Hex.stringify(CryptoJS.enc.Base64.parse(encrypted.toString()));
}

export function decryptAES(hexData, password, salt) {
  const key = deriveKey(password, salt);

  // Convert HEX back to Base64 for crypto-js
  const base64Data = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Hex.parse(hexData));

  const decrypted = CryptoJS.AES.decrypt(base64Data, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
}
